export const getElementForHash = (
  hash,
  documentObject = typeof document !== 'undefined' ? document : null
) => {
  if (typeof hash !== 'string' || !hash.startsWith('#') || !documentObject) return null;

  try {
    const id = decodeURIComponent(hash.slice(1));
    return id ? documentObject.getElementById(id) : null;
  } catch (_error) {
    return null;
  }
};
